import { PersonChangesInfo } from '@aibees/elephant/feature/search-table-people';
import { HttpMethod } from '@aibees/shared/definition';
import { useCurrentValue } from '@aibees/shared/hooks';
import { useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback, useMemo } from 'react';
import { PEOPLE_READ_API_CHANGES } from '../../constants';
import { ReadPersonRequest } from '../types';

let globalDebounceTimeout: NodeJS.Timeout | null = null;

export function useReadPersonChanges(id?: string) {
  const workspaceId = useWorkspace()?.id;
  const updatedIdRef = useCurrentValue(id);

  const api = useBaseQuery<ReadPersonRequest, PersonChangesInfo>(
    [useReadPersonChanges.name, updatedIdRef.current],
    {
      url: PEOPLE_READ_API_CHANGES.replace(':wid', String(workspaceId)).replace(
        ':id',
        String(updatedIdRef.current)
      ),
      method: HttpMethod.get,
    },
    {
      enabled: false,
    }
  );

  const debouncedRefetch = useCallback(() => {
    if (!updatedIdRef.current) return;
    if (globalDebounceTimeout) {
      clearTimeout(globalDebounceTimeout);
    }
    globalDebounceTimeout = setTimeout(() => {
      api.refetch();
      globalDebounceTimeout = null;
    }, 1000); // Adjust the delay as needed.
  }, [api, updatedIdRef.current]);

  return useMemo(() => ({ ...api, debouncedRefetch }), [api, debouncedRefetch]);
}
